<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5865 6029"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0" d="M5458 0l-5039 0c-489,0 -407,864 -407,864l5852 0c0,0 35,-864 -406,-864z"/>
  <polygon class="fil0" points="0,2204 5858,2204 5858,1141 0,1141 "/>
  <polygon class="fil0" points="0,3513 5858,3513 5858,2450 0,2450 "/>
  <polygon class="fil0" points="0,4754 5858,4754 5858,3691 0,3691 "/>
  <polygon class="fil0" points="0,6029 5858,6029 5858,4966 0,4966 "/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'JalousieClose',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
